import { useState } from 'react';

import Title from '../components/Title';
import Footer from '../components/Footer';

import TextInput from '../components/TextInput';

import { ANSWER_TYPE, type ScreenProps } from '../types';

const FreeText = ({
  questionId,
  title,
  description,
  format,
  type,
  required,
  properties,
  onNext,
  onSkip,
  savedAnswer,
  editMode,
}: ScreenProps) => {
  const [text, setText] = useState<string>(
    savedAnswer?.answers?.[0].value || '',
  );

  const disableNext =
    text.replace(/\s+$/g, '').trim().length < (properties.minimum || 0) &&
    required;

  const handleNext = () => {
    onNext({ questionId, title, format, answers: [{ value: text.trim() }] });
    setText('');
  };

  const handleSkip = () => {
    setText('');
    onSkip();
  };

  return (
    <section className="flex h-screen flex-col justify-between overflow-auto">
      <div>
        <Title title={title} description={description} className="mb-4 mt-6" />
        <TextInput
          textarea={type === ANSWER_TYPE.STRING}
          type={type === ANSWER_TYPE.INTEGER ? 'number' : 'text'}
          required={required}
          value={text}
          name={title}
          min={properties.minimum}
          max={properties.maximum}
          onChange={setText}
        />
      </div>
      <Footer
        disablePrimary={disableNext}
        showSecondary={!required || editMode}
        primaryLabel={editMode ? 'Done' : 'Next'}
        secondaryLabel={editMode ? 'Cancel' : 'Skip'}
        handlePrimaryButton={handleNext}
        handleSecondaryButton={handleSkip}
      />
    </section>
  );
};

export default FreeText;
